import formatTestimonial from "../format/testimonial";
import queryByDocType from "../queryByDocType";

export default async () => {
	const testimonials = await queryByDocType("testimonial");

	return testimonials.map(formatTestimonial);
};
